import React from 'react';
import { Hero, Stats, TestimonialsInitial, Problem, ProductPresentation, WhatYouGet, WhatEachTomeIncludes, Bonuses } from './components/SectionsPart1';
import { UrgencyCountdown, Pricing, MegapackDetail, TestimonialsExtended, Guarantee, FAQ, FinalCTA, Footer } from './components/SectionsPart2';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="font-sans text-purple-deep bg-cream overflow-x-hidden selection:bg-coral selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Stats data-id="element-3" />
      <TestimonialsInitial data-id="element-4" />
      <Problem data-id="element-5" />
      <ProductPresentation data-id="element-6" />
      <WhatYouGet data-id="element-7" />
      <WhatEachTomeIncludes data-id="element-8" />
      <Bonuses data-id="element-9" />
      <UrgencyCountdown data-id="element-10" />
      <Pricing data-id="element-11" />
      <MegapackDetail data-id="element-12" />
      <TestimonialsExtended data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
      <PurchaseNotification data-id="element-18" />
    </div>;
}